const url = process.env.NODE_ENV === 'production' ? 'https://nirogsathi-vor2.onrender.com/api/v1' : 'http://localhost:5000/api/v1';

export const getBaseUrl = () => {
  return url;
};
